import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Tooltip } from 'antd'
import { ModalForm, ProFormTextArea } from '@ant-design/pro-components'

async function fetchData(params, store) {
  const result = await store.externals.api.get(`/afterSales`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

function Update ({ data, store, visible, handles, onVisibleChange }) {
  const fileType = React.useMemo(() => store.config.getConstantPairs('FileType'), [])

  const getData = React.useCallback(data => {
    return Object.assign(data, {
      afterVideo: data.fileManageList?.filter(file => file.type == fileType.afterVideo).map(file => ({ ...file, filename: file.fileName })),
      afterPicture: data.fileManageList?.filter(file => file.type == fileType.afterPicture).map(file => ({ ...file, filename: file.fileName })),
      afterCompleteVideo: data.fileManageList?.filter(file => file.type == fileType.afterCompleteVideo).map(file => ({ ...file, filename: file.fileName })),
      afterCompletePicture: data.fileManageList?.filter(file => file.type == fileType.afterCompletePicture).map(file => ({ ...file, filename: file.fileName })),
    })
  }, [])

  const getFormData = React.useCallback(data => {
    let without = [
        'afterPicture'
      , 'afterVideo'
      , 'afterCompletePicture'
      , 'afterCompleteVideo'
    ]

    return Object.assign(R.omit(without, data), {
      fileManageList: [
        ...R.defaultTo([], data.afterVideo).map(file => ({ url: file.url, type: fileType.afterVideo, fileName: file.filename })),
        ...R.defaultTo([], data.afterPicture).map(file => ({ url: file.url, type: fileType.afterPicture, fileName: file.filename })),
        ...R.defaultTo([], data.afterCompleteVideo).map(file => ({ url: file.url, type: fileType.afterCompleteVideo, fileName: file.filename })),
        ...R.defaultTo([], data.afterCompletePicture).map(file => ({ url: file.url, type: fileType.afterCompletePicture, fileName: file.filename })),
      ]
    })
  }, [])

  return <ModalForm
    title='修改售后记录'
    layout='vertical'
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true
    }}
    onOpenChange={onVisibleChange}
    request={() => store.externals.api.get(`/afterSales/${data.id}`).then(getData)}
    onFinish={params => store.externals.api.put(`/afterSales/${data.id}`, getFormData(params)).then(() => handles.current.reload()).then(R.T)}
  >
    <UploadFile
      max={10}
      name='afterVideo'
      label='售后视频'
      fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
    />

    <UploadImage
      max={10000}
      name='afterPicture'
      label='售后图片'
      fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
    />

    <ProFormTextArea
      name='describes'
      label='问题描述'
      fieldProps={{ rows: 6 }}
      rules={[ { required: true, message: '请输入问题描述' } ]}
    />

    <UploadFile
      max={10}
      name='afterCompleteVideo'
      label='完成售后视频'
      fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
    />

    <UploadImage
      max={10000}
      name='afterCompletePicture'
      label='完成售后图片'
      fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
    />
  </ModalForm>
}

export default function List ({ store, refreshConstant }) {
  const [ selected, dispatch ] = React.useState('no')

  const columns = [
    {
      title: '订单编号',
      dataIndex: 'orderNumber',
    },
    {
      title: '客户姓名',
      dataIndex: 'customersName',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'customersPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'address',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'customersSourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '来源',
      dataIndex: 'customersSource',
    },
    {
      title: '售后状态',
      dataIndex: 'status',
      valueType: 'select',
      valueEnum: { yes: '已结束', no: '处理中' }
    },
    {
      title: '问题描述',
      dataIndex: 'describes',
      render: (_) => _.length > 30 ? <Tooltip title={<div className='text-gray-600'>{_}</div>} color='white' overlayInnerStyle={{ width: 400 }}><div className='cursor-pointer'>{_.slice(0, 30) + '...'}</div></Tooltip> : _,
    },
    {
      title: '开始时间',
      dataIndex: 'createTime',
    },
    {
      title: '结束时间',
      dataIndex: 'updateTime',
      render: (_, data) => data.status == 'yes' ? _ : '-',
    },
    {
      title: '创建人',
      dataIndex: 'salesName',
    },
  ]

  const cols = React.useMemo(() => {
    return columns.map(column => {
      let keys = [
          'customersName'
        , 'customersPhone'
        , 'customersSourceId'
        , 'address'
      ]

      return keys.includes(column.dataIndex) ? column : Object.assign(column, { hideInSearch: true })
    })
  }, [
    columns,
  ])

  const rowActions = [
    {
      name: '修改',
      visible: () => store.identity.hasPermission('/aftersales/list:update'),
      form: props => <Update {...props} store={store} refreshConstant={refreshConstant}/>,
    },
    {
      name: '结束',
      confirmType: 'modal',
      confirmMessage: '您确定结束这个售后吗？',
      visible: (data) => data.status == 'no' && store.identity.hasPermission('/aftersales/list:update'),
      onConfirm: (data, handles) => store.externals.api.put(`/afterSales/${data.id}`, { ...data, status: 'yes' }).then(() => handles.current.reload()).then(refreshConstant),
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个售后记录吗？',
      visible: () => store.identity.hasPermission('/aftersales/list:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/afterSales/${data.id}`).then(() => handles.current.reload()).then(refreshConstant),
    },
  ]

  return <div className='p-4'>
    <Table
      title='售后列表'
      columns={cols}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      params={{ status: selected }}
      scroll={{ }}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
      toolbar={{
        multipleLine: true,
        tabs: {
          activeKey: selected,
          onChange: dispatch,
          items: [
            { key: 'no', tab: '未完成' },
            { key: 'yes', tab: '已完成' },
          ],
        },
      }}
    />
  </div>
}
